import { Pipe, PipeTransform } from '@angular/core';
import { percentageToValue } from '@marmon/shared/types/common';

@Pipe({
	name: 'percentToValue',
	standalone: true,
})
export class PercentToValuePipe implements PipeTransform {
	transform(value: number | null) {
		const invalid = Number.isNaN(value) || !Number.isFinite(value);
		if (value === null || invalid) return '';
		return percentageToValue(value);
	}
}
